export const API_URL = "https://api.openweathermap.org/data/2.5/weather";
export const API_KEY = "071930e2f1a841b161d2078319f52d5d";
export const LOCATION_API_URL =
  "https://maps.googleapis.com/maps/api/geocode/json?";
export const LOCATION_API_KEY = "AIzaSyCqkc4bbYjxmPJ6y9OmE-_vUL4Gbc8riBc";
